/**
 * LoggerFactory — creates the appropriate logger based on environment.
 *
 * Development: ConsoleLogger (pretty-printed, colored).
 * Production: ProductionLogger (structured JSON).
 * Test: NoopLogger (silent).
 */

import type { Logger } from './types';
import { ConsoleLogger } from './ConsoleLogger';
import { ProductionLogger } from './ProductionLogger';

class NoopLogger implements Logger {
  debug(): void {}
  info(): void {}
  warn(): void {}
  error(): void {}
  audit(): void {}
}

export class LoggerFactory {
  private static instance: Logger | null = null;

  static create(): Logger {
    if (this.instance) return this.instance;

    const mode = import.meta.env.MODE;
    if (mode === 'test') {
      this.instance = new NoopLogger();
    } else if (import.meta.env.PROD) {
      this.instance = new ProductionLogger();
    } else {
      this.instance = new ConsoleLogger();
    }
    return this.instance;
  }

  static set(logger: Logger): void {
    this.instance = logger;
  }
}
